import { type ReactElement } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Group, Text, TextInput } from '@mantine/core'
import { toShowingCountText, useTranslation } from '@front/model'
import { ButtonRefresh, Page } from '@components'
import { useInfiniteServerState } from './useInfiniteServerState'
import { useClientState } from './useClientState'
import { ToggleContactColumns } from './ToggleContactColumns'
import { DownloadContactsCsv } from './DownloadCsv'
import { ContactTable } from './ContactTable'
import { ContactFilters } from './ContactFilters'

function Contacts(): ReactElement {
  const { t } = useTranslation()

  return (
    <Page>
      <Page.Heading title={t('Prospecting Activity')} />
      <ContactList />
    </Page>
  )
}

const ContactList = (): ReactElement => {
  const { t } = useTranslation()
  const clientState = useClientState()
  const serverState = useInfiniteServerState(clientState)
  const { isFetching, refetch, data } = serverState
  const { query, setQuery, selectedColumns, sorting, setSorting } = clientState

  return (
    <>
      <Page.FunctionBar>
        <div className='gap-2xl flex w-full flex-col'>
          <Group justify='space-between'>
            <Group gap='sm'>
              <TextInput placeholder={t('Filter')} value={query} onChange={(e) => setQuery(e.currentTarget.value)} />
              {serverState.total && (
                <Text>{toShowingCountText(data.length, serverState.total, 'contact')}</Text>
              )}
            </Group>
            <Group gap='sm'>
              <ToggleContactColumns {...clientState} />
              <DownloadContactsCsv data={data} />
              <ButtonRefresh isFetching={isFetching} refetch={refetch} />
            </Group>
          </Group>
          <ContactFilters {...clientState} />
        </div>
      </Page.FunctionBar>
      <Page.Content>
        <ContactTable
          selectedColumns={selectedColumns}
          sorting={sorting}
          setSorting={setSorting}
          {...serverState}
          data={data}
        />
      </Page.Content>
    </>
  )
}

export const Route = createFileRoute('/prospecting/')({
  component: Contacts,
})
